import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

// Pages
import Portfolio from './pages/portfolio/Portfolio'; 
import FYP from './pages/portfolio/FYP';

import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import Devices from './pages/Devices';
import Alerts from './pages/Alerts';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Profile from './pages/Profile';

// Components
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';

import './App.css';

function ChatbotManager() {
    const location = useLocation();

    useEffect(() => {
        // 1. Cleanup the previous widget DOM elements so they don't duplicate
        const existingFab = document.querySelector('.ai-widget-fab');
        const existingWindow = document.querySelector('.ai-widget-window');
        if (existingFab) existingFab.remove();
        if (existingWindow) existingWindow.remove();

        // 2. Determine which bot to load based on the current URL
        const isFypPage = location.pathname.includes('/fyp');
        
        // REPLACE THESE WITH YOUR ACTUAL INSTANCE IDs
        const activeInstanceId = isFypPage ? "inst_e6ba36e5" : "inst_d0abede8";
        const activeThemeColor = isFypPage ? "#10b981" : "#4f46e5"; // Emerald for FYP, Indigo for Main
        const activeMessage = isFypPage 
            ? "Welcome to the RF Sensing Clinical Dashboard. Ask me about our SDR architecture or AI triage."
            : "Welcome to Synapse Trio. How can I assist you?";

        // 3. Wait for the widget.js script to load, then initialize
        const initWidget = () => {
            if (window.AIRuntimeWidget) {
                window.AIRuntimeWidget.init({
                    instanceId: activeInstanceId,
                    apiHost: "https://aiinst-backend.onrender.com",
                    themeColor: activeThemeColor,
                    welcomeMessage: activeMessage
                });
            } else {
                setTimeout(initWidget, 500); // Retry in 500ms if script is still downloading
            }
        };

        initWidget();
    }, [location.pathname]); // Re-run this effect every time the URL changes

    return null; // This component doesn't render any visible React UI
}
// ✅ 1. MainLayout (Handles PiWatch App & Portfolio)
// ✅ 1. MainLayout (Handles PiWatch App & Portfolio)
function MainLayout() {
    const location = useLocation();
    
    // ONLY show the PiWatch sidebar on actual PiWatch routes. 
    // This makes it 100% bulletproof against weird URLs.
    const piwatchRoutes = ["/dashboard", "/devices", "/alerts", "/reports", "/settings", "/profile"];
    const showSidebar = piwatchRoutes.includes(location.pathname);

    // Authentication State
    const [token, setToken] = useState(localStorage.getItem('piwatch_token'));

    const handleLogin = (newToken) => {
        localStorage.setItem('piwatch_token', newToken);
        setToken(newToken);
    };

    const handleLogout = () => {
        localStorage.removeItem('piwatch_token');
        setToken(null);
    };

    return (
        <div className="flex h-screen bg-darkBg text-white overflow-hidden">
            {/* PiWatch Sidebar */}
            {showSidebar && <Sidebar />}

            <div className="flex-1 flex flex-col overflow-hidden relative">
                {/* PiWatch Navbar */}
                {showSidebar && <Navbar onLogout={handleLogout} />}

                <main className="flex-1 overflow-x-hidden overflow-y-auto bg-darkBg relative">
                    <Routes>
                        {/* Public Pages */}
                        <Route path="/" element={<Portfolio />} />
                        <Route path="/:author" element={<Portfolio />} />
                        
                        <Route path="/piwatch-welcome" element={<LandingPage onNavigate={() => {}} />} />
                        <Route path="/auth" element={
                            token ? <Navigate to="/dashboard" /> : <AuthPage onLogin={handleLogin} />
                        } />

                        {/* Protected PiWatch Pages */}
                        <Route path="/dashboard" element={token ? <Dashboard /> : <Navigate to="/auth" />} />
                        <Route path="/devices" element={token ? <Devices /> : <Navigate to="/auth" />} />
                        <Route path="/alerts" element={token ? <Alerts /> : <Navigate to="/auth" />} />
                        <Route path="/reports" element={token ? <Reports /> : <Navigate to="/auth" />} />
                        <Route path="/settings" element={token ? <Settings /> : <Navigate to="/auth" />} />
                        <Route path="/profile" element={token ? <Profile /> : <Navigate to="/auth" />} />

                        {/* Catch-all */}
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </main>
            </div>
        </div>
    );
}

// ✅ 2. App Component
function App() {
    return (
        <Router>
            <ChatbotManager />
            <Routes>
                {/* ✅ FIX: FYP is now a TOP-LEVEL route. 
                   It is NOT inside MainLayout. This ensures it scrolls properly.
                */}
                <Route path="/fyp" element={<FYP />} />

                {/* All other routes go through MainLayout */}
                <Route path="/*" element={<MainLayout />} />
            </Routes>
        </Router>
    );
}

export default App;